
import { useQueryClient } from '@tanstack/react-query';
import { UserCategory } from '@/types';

export const useCategoryOptimisticUpdates = () => {
  const queryClient = useQueryClient();

  const optimisticUpdateCategory = (id: string, updates: Partial<UserCategory>) => {
    queryClient.setQueryData<UserCategory[]>(['categories'], (old) => {
      if (!old) return old;
      return old.map(cat => 
        cat.id === id ? { ...cat, ...updates } : cat
      ).sort((a, b) => (a.position || 0) - (b.position || 0));
    });
  };

  const optimisticAddCategory = (category: UserCategory) => {
    queryClient.setQueryData<UserCategory[]>(['categories'], (old) => {
      if (!old) return [category];
      return [...old, category].sort((a, b) => (a.position || 0) - (b.position || 0));
    });
  };

  const optimisticDeleteCategory = (id: string) => {
    queryClient.setQueryData<UserCategory[]>(['categories'], (old) => {
      if (!old) return old;
      return old.filter(cat => cat.id !== id);
    });
  };

  const optimisticUpdateCategoriesOrder = (reorderedCategories: UserCategory[]) => {
    queryClient.setQueryData<UserCategory[]>(['categories'], reorderedCategories);
  };

  return {
    optimisticUpdateCategory,
    optimisticAddCategory,
    optimisticDeleteCategory,
    optimisticUpdateCategoriesOrder
  };
};
